import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import MobileStoreButton from 'react-mobile-store-button';
import { inject, observer } from "mobx-react";

// Translations
import _useTranslate from '../hooks/_useTranslate';

// The app-download section. The store BUTTONS already read ANDROID_URL / IOS_URL from settings,
// but the two QR images beside them used to be static PNGs of the generic BringFood listings
// (src/img/qr-code-bringfood-*.png) - so a white-label shop advertised its own app in the button
// and sent every scan to somebody else's. azel is exactly that case: package gr.appdate.azel, its
// own Play listing, and no App Store listing at all yet.
//
// Both codes are now GENERATED from the same settings URLs the buttons use, and each half renders
// only when its URL exists: a shop with one app shows one code, and a shop with none never reaches
// here (feathersStore.showAppDownload() gates the whole section).
const QrCode = ({ feathersStore }) => {

  let common = _useTranslate(feathersStore.language, "common");

  const androidUrl = feathersStore.androidStoreUrl();
  const urlIos = feathersStore.iosStoreUrl();
  const imageIos = 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1625702400&h=756295c0d4e95f66799873c9eee485ea'

  //level 'H' matches the dashboard's printed codes: a scan target that ends up on a table card or a
  //shop window has to survive being smudged, curled or partly covered.
  const storeQr = (url) => (
    <QRCodeCanvas
      className="qr-hanging-image"
      value={url}
      size={140}
      level="H"
      includeMargin={true}
    />
  );

  return (
    <div className="qr-code-container">
      <div className="arrow-down"></div>
      <div className='qr-codes-wrap'>
        <div className="section column-flex-start">
          <div className='text-1'>{common.qrCodeBuy}</div>
          <div className="line-20"></div>
          <div className='text-2'>{common.qrCodeBuyMobile}</div>
        </div>
        <div className="section row-flex-center">
          <div className='row-flex-end-wrap section-2'>
            {androidUrl && (
              <div className="column-flex-center qr-component">
                <div className="hanging-wrapper">
                  <div className="qr-row">
                    <div className= "dot"></div>
                    <div className="hanging-line left-rotate "></div>
                    <div className="hanging-line right-rotate"></div>
                  </div>
                  {storeQr(androidUrl)}
                </div>
                <div className="scan-desk">Android</div>
              </div>
            )}
            {urlIos && (
              <div className={`column-flex-center qr-component${androidUrl ? ' ml-3' : ''}`}>
                <div className="hanging-wrapper">
                  <div className="qr-row">
                    <div className= "dot"></div>
                    <div className="hanging-line left-rotate "></div>
                    <div className="hanging-line right-rotate"></div>
                  </div>
                  {storeQr(urlIos)}
                </div>
                <div className="scan-desk">iOS</div>
              </div>
            )}
          </div>
        </div>
      </div>
        <div className="store-icons">
            <div className='text-1 header-mobile'>{common.qrCodeBuy}</div>
            {androidUrl && (
              <div className='android-icons'>
                  <h5>{common.qrCodeForAndroid}</h5>
                  <MobileStoreButton
                      store="android"
                      url={androidUrl}
                      linkProps={{ title: 'Android Store Button' }}
                      style={{ height: '60px', width: '140px' }}
                  />
              </div>
            )}
            {urlIos && (
              <div className='ios-icons'>
                  <h5>{common.qrCodeForIos}</h5>
                   <a href={urlIos} target="_blank" rel="noopener noreferrer">
                    <img src={imageIos} alt="Download on the App Store" loading="lazy" decoding="async" />
                  </a>
              </div>
            )}
        </div>
    </div>
    )
}

export default inject('feathersStore')(observer(QrCode));
